import { render, staticRenderFns } from "./NotFind.vue?vue&type=template&id=8f4cd346&scoped=true&"
import script from "./NotFind.vue?vue&type=script&lang=js&"
export * from "./NotFind.vue?vue&type=script&lang=js&"
import style0 from "./NotFind.vue?vue&type=style&index=0&id=8f4cd346&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4cd346",
  null
  
)

export default component.exports